import { Navbar } from './LandingPageNav';
import { Hero } from './HeroSection';
import { About } from './About';
import { Features } from './Features';
import { Services } from './Services';
import { Pricing } from './Pricing';
import { Footer } from './Footer';
import '../../../index.css';

export const LandingPage = () => {
  return (
    <div className="h-auto">
      <Navbar />
      <Hero />
      <About />
      <Features />
      <Services />
      <Pricing />
      <Footer />
    </div>
  );
};
